export default __webpack_public_path__ + "static/media/cfx-riu-1.e2a92579.png";